import React, { Component, ErrorInfo, ReactNode } from 'react';

type Props = { children: ReactNode; fallback?: ReactNode };
type State = { hasError: boolean };

export class ErrorBoundary extends Component<Props, State> {
  state: State = { hasError: false };

  static getDerivedStateFromError(): State {
    return { hasError: true };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo): void {
    console.error('ErrorBoundary:', error, errorInfo);
  }

  render(): ReactNode {
    if (this.state.hasError) {
      return this.props.fallback ?? (
        <div style={{ padding: 48, textAlign: 'center', maxWidth: 560, margin: '0 auto' }}>
          <h1>Something went wrong</h1>
          <p style={{ color: '#666', marginTop: 16 }}>Please try again or contact your clinician for a new link.</p>
        </div>
      );
    }
    return this.props.children;
  }
}
